import { createRouter, createWebHistory } from 'vue-router'
import BaseLayout from '@/components/BaseLayout.vue'
import ErrorPage from '@/components/ErrorPage.vue' // Calea către componenta ta
const routes = [
  // 🔹 Pagini publice (cu BaseLayout)
  {
    path: '/',
    component: BaseLayout,
    children: [
      { path: '', component: () => import('@/components/HomePage.vue') },
      { path: 'despre', component: () => import('@/components/AboutUs.vue') },
      { path: 'contact', component: () => import('@/components/ContactUs.vue') },
      { path: 'politica-confidentialitate', component: () => import('@/components/PrivacyPolicy.vue') },
      { path: 'termeni-si-conditii', component: () => import('@/components/TermsConditions.vue') },
      { path: 'anunturi', component: () => import('@/components/AnnouncementPage.vue') },
      { path: 'anunturi/:id', component: () => import('@/components/AnnouncementDetails.vue') },
    ],
  },
{
    path: '/error',
    name: 'ErrorPage', // 👈 Același nume ca în store
    component: ErrorPage
  },
  // 🔸 Pagini admin (fără layout)
  {
    path: '/admin/login',
    component: () => import('@/components/AdminLogin.vue'),
  },
  {
    path: '/admin/dashboard',
    component: () => import('@/components/AdminDashboard.vue'),
  },

  // 🔻 Fallback 404
  {
    path: '/:pathMatch(.*)*',
    redirect: '/',
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    return { top: 0 }
  },
})

export default router
